import { Box, IconButton, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  DeleteGreyIcon,
  EditGreyIcon,
  ImageGreyIcon,
} from "../../assets/images/FrankIcons";
import { RootState } from "../../Store";
import FrankConstants from "../../utils/FrankConstants";
import { useMediaQuery, useTheme } from "@mui/system";
 
function CustomAnnouceCard(props: any) {
  const selector = useSelector((state: RootState) => state.mainApp)
  const {
    productTitle,
    productImage,
    productheight,
    productLength,
    productWidth,
    imageQuantity,
    handleEdit,
    shipmentQuantity,
    productSize,
    handleRemove,
  } = props;

   const theme = useTheme();
   
     const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
     const styles = {
      card: {
        display: "flex",
        alignItems: "center",
        backgroundColor: '#F4F3F6',
        borderRadius: "24px",
        height: "100%",
        minHeight: "142px",
      },
      imageContainer: {
        flex: "0 0 110px",
        marginRight: "16px",
        marginLeft: "16px",
      },
      image: {
        
      },
      detailsContainer: {
        flex: "1 1 auto",
      },
      title: {
         color: "#080626",
        fontSize: screen_1024?"18px" :"16px",
        fontFamily: "montserrat-Bold",
        display:'flex',
        gap:7,
        alignItems:'center'
      },
      dimensions: {
        color: "#78778A",
        fontSize: screen_1024 ? "16px" :"12px",
        fontFamily: "montserrat-Regular",
        display:"flex",
        alignItems:"center",
        gap:0.5
      },
      iconTextContainer: {
        display: "flex",
        alignItems: "center",
        marginTop: "8px",
        gap:1
      },
      icon: {
        color: "#888",
        marginRight: "4px",
      },
      imageCount: {
        color: "#888",
        fontFamily: "Raleway-Variable",
        fontSize: "16px",
      },
      rightContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        marginLeft: "auto",
        marginRight: "16px",
      },
      quantity: {
         color: "#080626",
        fontSize: "20px",
        fontFamily: "montserrat-Bold",
      },
       
      actionIcons: {
        display: "flex",
        justifyContent: "space-between",
      },
      iconButton: {
        padding: "8px",
      },
      actionIcon: {
        color: "#888",
      },
    };
   const deliveryType = FrankConstants.packageSize(selector.lang)?.find(
      (a: any) => a.key === productSize
    );

    const transSizes = (item: any) => {
       
        const deliveryType = FrankConstants.packageSize(selector.lang)?.find(
          (a: any) => a.size_trans === item?.size_trans
        );
        return deliveryType?.weight_fr;
      };
    
  return (
    <Box sx={styles.card}>
      <Box sx={styles.imageContainer} >
        <img
          src={productImage ?? "https://via.placeholder.com/100"}
          alt="Table en bois clair"
          style={{width: "100%",
            borderRadius: "16px",
            maxHeight:"110px",
            objectFit:"contain"}}
         />
      </Box>
      <Box sx={styles.detailsContainer}>
        <Typography sx={styles.title} >
          {productTitle ?? "Table en bois clair"}  <Typography sx={styles.quantity}>x{shipmentQuantity ?? 1}</Typography>
        </Typography>

        <Typography sx={styles.dimensions}>
          {productLength ?? 210} x {productWidth ?? 120} x {productheight ?? 40} -
          <Typography style={{fontFamily:'montserrat-Regular',fontSize:screen_1024? 16:12}} >{   deliveryType?.size_trans ?? "Extra large"}{shipmentQuantity > 1 ? "s" : null} {`(${transSizes(deliveryType)})`}    </Typography>

        </Typography>
        <Box sx={styles.iconTextContainer}>
          <ImageGreyIcon />
          <Typography sx={styles.imageCount}>x {imageQuantity ?? 3}</Typography>
        </Box>
      </Box>
      
      <Box sx={styles.actionIcons}>
        <IconButton onClick={handleEdit} sx={styles.iconButton}>
          <EditGreyIcon />
        </IconButton>
        <IconButton onClick={handleRemove} sx={styles.iconButton}>
          <DeleteGreyIcon />
        </IconButton>
      </Box>
    </Box>
  );
}

CustomAnnouceCard.defaultProps = {
  productTitle: "",
  productImage: "",
  productheight: "",
  productLength: "",
  productWidth: "",
  imageQuantity: "",
  shipmentQuantity: "1",
  productSize: "",
  handleEdit: {},
};

CustomAnnouceCard.propTypes = {
  productTitle: PropTypes.any,
  productImage: PropTypes.any,
  productheight: PropTypes.any,
  productLength: PropTypes.any,
  productWidth: PropTypes.any,
  imageQuantity: PropTypes.any,
  shipmentQuantity: PropTypes.any,
  productSize: PropTypes.any,
  handleEdit: PropTypes.func,
  handleRemove: PropTypes.func,
};
export default CustomAnnouceCard;
